// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accounting-document-summary-renderer {\n  height: 100%;\n}\n.accounting-document-summary-renderer .add-and-remove {\n    position: absolute;\n    width: 50px;\n    height: 50px;\n    left: -50px;\n    border: 1px solid #000;\n    z-index: 99999;\n}\n", ""]);
// Exports
module.exports = exports;
